import React from "react";
import { outcomes } from "../../content/siteContent";
import { SectionHeading } from "./primitives";
import { Reveal } from "../motion/Reveal";

export const Outcomes = () => (
  <section id="outcomes" data-testid="outcomes-section" className="bg-white py-24 lg:py-32 border-t border-hair">
    <div className="container-page">
      <SectionHeading eyebrow={outcomes.eyebrow}>{outcomes.heading}</SectionHeading>

      <div className="mt-16 grid sm:grid-cols-2 lg:grid-cols-3 border-t border-l border-hair">
        {outcomes.items.map((o, i) => (
          <Reveal
            key={o.title}
            delay={(i % 3) * 0.08}
            className="border-r border-b border-hair p-8 lg:p-10 group hover:bg-offwhite transition-colors duration-300"
          >
            <span className="font-display font-bold text-sm text-teal">
              {String(i + 1).padStart(2, "0")}
            </span>
            <h3 className="mt-4 font-display font-bold text-navy text-lg lg:text-xl tracking-tight leading-snug">
              {o.title}
            </h3>
            <p className="mt-3 text-slate-ink text-sm lg:text-[15px] leading-relaxed">{o.desc}</p>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
